import React from "react";
import Link from "./Link";

export default (props) => {
  return <Link size="small" buttonSize="small" {...props} />;
};
